module.exports = __webpack_public_path__ + "img/talin-logo-red-white.c3c18ae1.png";